(function () {
  "use strict";

  document.querySelectorAll(".nuvra-collections-preview__row").forEach(function (row) {
    initPreviewRow(row);
  });

  function initPreviewRow(row) {
    var track = row.querySelector("[data-nuvra-preview-row]");
    var prev = row.querySelector("[data-nuvra-preview-prev]");
    var next = row.querySelector("[data-nuvra-preview-next]");
    if (!track || track.dataset.nuvraPreviewBound === "1") return;
    track.dataset.nuvraPreviewBound = "1";

    function scrollBy(direction) {
      var amount = Math.max(260, track.clientWidth * 0.75) * direction;
      track.scrollBy({ left: amount, behavior: "smooth" });
    }

    function updateNav() {
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= maxScroll;
    }

    if (prev) prev.addEventListener("click", function () { scrollBy(-1); });
    if (next) next.addEventListener("click", function () { scrollBy(1); });
    track.addEventListener("scroll", updateNav, { passive: true });
    track.addEventListener("nuvra-trending-updated", updateNav);
    updateNav();
  }
})();
